import { createReducer } from '@reduxjs/toolkit';
import * as ua from './userActions';
import { buildActionStatus, actionManager } from '../utils';

const initialState = {
  firstName: '',
  lastName: '',
  email: '',
  moodle: false,
  classMode: null,
  userId: '',
  cmsId: '',
  isRecordingUser: false,
  meetings: [],
  admin: false,
  role: '',
  actionStatus: buildActionStatus(ua),
};

const userReducer = createReducer(initialState, {
  [ua.initAction]: (state, { payload: { key } }) =>
    actionManager(state, key, { loading: true, error: '' }),
  [ua.successAction]: (state, { payload: { key } }) =>
    actionManager(state, key, { loading: false, error: '' }),
  [ua.errorAction]: (state, { payload: { key, error } }) =>
    actionManager(state, key, { loading: false, error }),
  [ua.setUserAction]: (state, { payload }) => ({
    ...state,
    firstName: payload.firstName,
    lastName: payload.lastName,
    email: payload.email,
    classMode: payload.classMode,
    moodle: payload.moodle,
    userId: payload.userId,
    cmsId: payload.cmsId,
    meetings: payload.meetings,
    admin: payload.admin,
    role: payload.role,
    isRecordingUser: payload.isRecordingUser,
  }),
  [ua.setClassModeAction]: (state, { payload }) => ({ ...state, classMode: payload.classMode }),
  [ua.resetUserAction]: () => initialState,
  [ua.getUserAction]: (state) => ({
    ...state,
    loading: { ...state.loading, getUser: true },
  }),
  [ua.createUserAction]: (state) => ({
    ...state,
    loading: { ...state.loading, getOrCreateUser: true },
  }),
  [ua.guestLoginAction]: (state) => actionManager(state, 'guestLoginAction', { loading: true }),
});

export default userReducer;
